export default [
    {
        path: '/print-payslip/id/:payrollId/',
        name: 'print-payslip',
        component: () => import('source/pages/PrintPayslip.vue'),
        meta: {
            title: 'Payslip - HQZEN',
            loginRequired: true,
            canDisplayGlobalModals: false
        },
    },
    {
        path: '/print-leave/id/:leaveId/',
        name: 'print-leave',
        component: () => import('source/pages/employment/leaves/PrintLeaveDetails.vue'),
        meta: {
            title: 'Leave Details - HQZEN',
            loginRequired: true,
            canDisplayGlobalModals: false
        },
    },
    {
        path: '/print-separation-documents/id/:separationId/',
        name: 'print-separation-documents',
        component: () => import('source/pages/SeparationPrint.vue'),
        meta: {
            title: 'Separation - HQZEN',
            loginRequired: true,
            canDisplayGlobalModals: false
        },
    }
];
